export class DroneCode {
    public static CUSTOM_DRONE: number = 1;
    public static DS30: number = 35;
}